import React from 'react';

const createReactClass = require('create-react-class');
const TestLogin = createReactClass({
  getInitialState() {
    return {
      email: "",
      passcode: ""
    }
  },
  handleSubmit(e){
    e.preventDefault();
    console.log(this.props);
    //   console.log(this.state.email);
      this.props.testLogin(this.state.email, this.state.passcode);
  },
  handleInput(evt){
    this.setState({email:evt.target.value});
  },
  handleInputPC(evt){
    this.setState({passcode:evt.target.value});
  },
  render() {
    return (
        // <div>
        //     <h1>God Login</h1>
        //     <input type="text" defaultValue={this.state.email} onInput={this.handleInput}/>
        //     <button onClick={this.handleSubmit}>Go</button>
        // </div>
        <div>
        <div className="page-login header-minimal-head">

          <header className="site-header header-minimal">
            <div className="container">

              <nav className="top-nav">
                <ul>

                </ul>
              </nav>
            </div>
          </header>
          <div className="body-wrapper signinpage">
            <section className="container login">

              <div className="login-header clearfix">
                <h1>Welcome back!</h1>
              </div>

              <div className="login-wrapper clearfix">

                <div className="left">


                  {/*Sign In Form*/}
                  <div className="sign-in">
                    <div className="login-form">
                      <form id="login_form" onSubmit={this.handleSubmit}>
                        <div className="form-input">
                          <div className="input-wrapper group-input">
                            <div>
                              <label>Email address </label>&nbsp;
                              <label ref="errors_email" className="disnone"></label>
                              <input type="text" maxLength="50" className="form-control" onInput={this.handleInput} defaultValue={this.state.email} autoFocus />
                            </div>
                            <div>
                              <label>Passcode </label>&nbsp;
                              <label ref="errors_email" className="disnone"></label>
                              <input type="password" maxLength="50" className="form-control" onInput={this.handleInputPC} defaultValue={this.state.passcode} autoFocus />
                            </div>
                          </div>

                        </div>

                        <div className="submit">
                          <button type="submit" className="btn btn-login align-right btn-orange">
                            Sign in using our secure server
                                                </button>
                          
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>


        </div>
      </div>
    );
  },
});

export default TestLogin;



/** WEBPACK FOOTER **
 ** ./src/components/TestLogin.js
 **/